export default "__VITE_PUBLIC_ASSET__5cd81224__"